import { createContext } from 'react'

export const WellnessTileNavigationContext = createContext({
  isTileDrawerOpen: false,
  drawerState: null,
  getTileDrawerLinkState: () => undefined,
  openTileDrawer: () => {},
  closeTileDrawer: () => {},
  backFromTileDrawer: () => {},
  openTileAsPage: () => {},
})
